import { render, staticRenderFns } from "./iron.vue?vue&type=template&id=3e9241f9&scoped=true"
import script from "./iron.vue?vue&type=script&lang=js"
export * from "./iron.vue?vue&type=script&lang=js"
import style0 from "./iron.vue?vue&type=style&index=0&id=3e9241f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9241f9",
  null
  
)

export default component.exports